class NavigationStateManager {
  private static instance: NavigationStateManager;
  private isTransitioning = false;
  private timeoutId?: NodeJS.Timeout;

  private constructor() {}

  static getInstance(): NavigationStateManager {
    if (!NavigationStateManager.instance) {
      NavigationStateManager.instance = new NavigationStateManager();
    }
    return NavigationStateManager.instance;
  }

  startTransition() {
    this.isTransitioning = true;
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.timeoutId = setTimeout(() => {
      this.isTransitioning = false;
    }, 1000);
  }

  isInTransition(): boolean {
    return this.isTransitioning;
  }

  endTransition() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.isTransitioning = false;
  }
}

export const navigationStateManager = NavigationStateManager.getInstance();
